import { Box, Checkbox, CheckboxProps, GridItem } from '@coolblue-development/freddy';
import { useTranslation } from '@i18n/useTranslation';
import React from 'react';

import { MatrixValuesType } from '../MatrixHelper';

type Props = {
  columnLabel: string;
  label: string;
  columnIndex: number;
  matrixValues: MatrixValuesType;
  setMatrixValues: React.Dispatch<React.SetStateAction<MatrixValuesType>>;
  selectAllConfig?: { checkedCount: number; totalCount: number };
  className?: string;
  onHover?: (hoverActive: boolean) => void;
};

export const MatrixCheckboxCell = ({
  columnLabel,
  label,
  columnIndex,
  matrixValues,
  setMatrixValues,
  selectAllConfig,
  className,
  onHover
}: Props) => {
  const { t } = useTranslation('vacancyDetail.applicationForm.questions.matrixQuestion');
  const isChecked = matrixValues.get(columnLabel)?.get(label) || false;

  const getFirstRowProps = (): CheckboxProps => {
    if (!selectAllConfig) return {};

    const allChecked = selectAllConfig.checkedCount === selectAllConfig.totalCount;
    const indeterminate = selectAllConfig.checkedCount > 0 && !allChecked;

    return {
      'aria-label': allChecked
        ? t('deselectAllOptions', { columnLabel })
        : t('selectAllOptions', { columnLabel }),
      checked: allChecked,
      indeterminate,
      onChange: e => {
        const updatedMatrix = new Map(matrixValues);
        updatedMatrix.get(columnLabel)?.forEach((_, rowLabel) => {
          updatedMatrix.get(columnLabel)?.set(rowLabel, e.target.checked);
        });
        setMatrixValues(updatedMatrix);
      }
    };
  };

  return (
    <GridItem
      component='td'
      column={columnIndex + 2}
      p='0'
      className={className}
      onMouseEnter={() => onHover?.(true)}
      onMouseLeave={() => onHover?.(false)}
      onFocus={() => onHover?.(true)}
      onBlur={() => onHover?.(false)}
    >
      <Box
        component='label'
        p={200}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '100%',
          height: '100%',
          '&:hover': { cursor: 'pointer' }
        }}
      >
        <Checkbox
          name={`${columnLabel} - ${label}`}
          aria-label={
            isChecked
              ? t('deselectOption', { rowLabel: label, columnLabel })
              : t('selectOption', { rowLabel: label, columnLabel })
          }
          value={`${columnLabel} - ${label}`}
          checked={isChecked}
          onChange={e => {
            const updatedMatrix = new Map(matrixValues);
            updatedMatrix.get(columnLabel)?.set(label, e.target.checked);
            setMatrixValues(updatedMatrix);
          }}
          {...getFirstRowProps()}
        />
      </Box>
    </GridItem>
  );
};
